<template>
    <v-content>
        <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>

        <v-row>

            <v-col xl="2" md="3" sm="6" cols="12" v-for="title in cardData"
                   v-bind:key="title.link"
                   class="viewCard">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <router-link :to="title.link">

                            <HoverCard :cardData="title"></HoverCard>

                        </router-link>
                    </template>

                </v-tooltip>
            </v-col>
        </v-row>

    </v-content>
</template>

<script>
    /*import CompanyDashboardMenu from "./CompanyDashboardMenu";*/
    import HoverCard from '@/components/HoverCard'

    import {mapGetters} from "vuex";

    export default {
        name: "CompanySettings",
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            cardData() {
             return   [

                    {
                        name: "खसी वोका तथा च्याङ्ग्रा कारोवारको विवरण",
                        link: "/upload/direct2"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "प्रस्तावित दरवन्दीको विवरण",
                        link: "/upload/direct3"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "खाद्यान्न परिचालनको अवस्था",
                        link: "/upload/direct4"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "अनुमानित ढुवानी भाडा",
                        link: "/upload/direct5"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "आय स्रोत तथा खर्च अनुमान",
                        link: "/upload/direct6"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "बार्षिक नीति तथा कार्यक्रम",
                        link: "/upload/direct7"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: this.$t('upload_document'),
                        link: "/upload/direct8"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "पुजिगत तर्फको खर्च समिक्षा",
                        link: "/upload/direct9"
                        , icon: "mdi-receipt"
                    },
                    {
                        name: "प्रयोगकर्ताको लागि म्यानुअल अपलोड गर्नुहोस",
                        link: "/Upload/userManual"
                        , icon: "mdi-receipt"
                    },

                ]
            }
            
        },
        data() {
            return {
                breadcrumbsItems: [],
               
            }
        },
        methods: {},
        mounted() {

        },
        components: {HoverCard}
    }
</script>

<style lang="scss" scoped>
    .options {
        border: 2px solid white;
    }

</style>
